import React, { lazy, FC, Suspense } from 'react'
import { Route, Routes, useSearchParams } from 'react-router-dom'
import { clientConfig } from '@mortgage-pos/data'
import { environment } from '@mortgage-pos/ui/env'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import { importRetry } from '@mortgage-pos/ui/utils/importRetry'
import { evaluateWelcomePageVariant } from './utils/monarchHelpers'

const App = lazy(() => importRetry(() => import('./App')))
const Welcome = lazy(() => importRetry(() => import('./Welcome')))
const WelcomeSimple = lazy(() => importRetry(() => import('./WelcomeSimple')))
const WelcomePop = lazy(() => importRetry(() => import('./WelcomePop')))

function useWelcomeTemplate() {
  const [searchParams] = useSearchParams()
  const urlTemplate = searchParams.get('template')

  const [state, setState] = React.useState({
    template: urlTemplate,
    isLoading: urlTemplate ? false : true,
  })

  React.useEffect(() => {
    if (urlTemplate) return

    async function fetchMonarchTemplate() {
      try {
        const template = await evaluateWelcomePageVariant()
        setState({
          template,
          isLoading: false,
        })
      } catch (error) {
        setState({
          template: 'default',
          isLoading: false,
        })
      }
    }

    fetchMonarchTemplate()
  }, [urlTemplate])

  return state
}

function WelcomeRouter() {
  const { template, isLoading } = useWelcomeTemplate()

  if (isLoading) {
    return <div>Loading...</div>
  }

  switch (template) {
    case 'simple':
      return <WelcomeSimple />
    case 'pop':
      return <WelcomePop />
    default:
      return <Welcome />
  }
}

const AppRouter: FC = () => {
  return (
    <Routes>
      <Route
        path={`/welcome`}
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <WelcomeRouter />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<div>Loading..</div>}>
            <App />
          </Suspense>
        }
      />
    </Routes>
  )
}

export default withLDProvider({
  ...clientConfig,
  clientSideID: environment.launchDarkly.clientId,
})(AppRouter)
